if (typeof CidaasPOCC === "undefined") {

  class CidaasPOCC extends HTMLElement {
    constructor() {
      super();
      window.debugMode &&
        console.log(
          "[cidaas-pocc]",
          "CidaasPOCC constructor called"
        );
      this.userDetails = window?.cidaasVariables?.user_details;
      this.additionalServices = window?.cidaasVariables?.additional_services;
      this.lastDate = null;
      this.loaded = false
      this.enabled = false
      this.formSubmitting = false;
    }
  
    connectedCallback() {
      window.debugMode &&
        console.log(
          "[cidaas-pocc]",
          "CidaasPOCC connected to DOM"
        );

      this.inputDate = this.querySelector('[name="selected_date"]');
      this.inputConsent = this.querySelector('[type="checkbox"]');
      this.buttonActivate = this.querySelector('.ds-pocc-consent__button-activate');
      this.buttonDeactivate = this.querySelector('.ds-pocc-consent__button-deactivate');
      this.buttonSave = this.querySelector('.ds-pocc-consent__button-save');
      this.buttonReset = this.querySelector('.ds-pocc-consent__button-reset');

      this.inputDate.addEventListener('change', (event) => {
        this.updateButtonState();
      });

      this.inputConsent.addEventListener('change', (event) => {
        this.updateButtonState();
      });

      this.buttonActivate.addEventListener('click', this.onActivatePOCC.bind(this));
      this.buttonDeactivate.addEventListener('click', this.onDeactivatePOCC.bind(this));
      this.buttonSave.addEventListener('click', this.onSavePOCC.bind(this));
      this.buttonReset.addEventListener('click', this.onResetPOCC.bind(this));

      this.attachEventListeners();
    }

    onResetPOCC(event) {
      this.updateFormUI();
      this.updateButtonState();
    }

    async onSavePOCC(event) {
      if (!this.formSubmitting) {
        this.formSubmitting = true;
        
        this.buttonSave.setAttribute('aria-busy', 'true');
        const fetchAddServicesUrl = `${this.userDetails.profile.iss}/camlog-webhook-srv/additionalservice/addon`
        const poccUpdate = await fetch(fetchAddServicesUrl, {
          method: 'POST', 
          headers: {
            'Content-Type': 'application/json',
            'Authorization': `Bearer ${this.userDetails.access_token}` 
          },
          body: JSON.stringify({
            "pocc_postOperativeCareCoach": true,
            "pocc_surgeryDate": this.inputDate.value
          })
        }).then((resp) => {
          return resp.json()
        });

        if (poccUpdate?.success) {
          const poccObject = await fetch(`${this.userDetails.profile.iss}/camlog-webhook-srv/additionalservice/addon`, {
            method: 'GET',
            headers: {
              'Content-Type': 'application/json',
              'Authorization': `Bearer ${this.userDetails.access_token}`
            }
          }).then((resp) => {
            return resp.json()
          });

          this.additionalServices = poccObject;
          window.cidaasVariables.additional_services = poccObject;

          this.buttonSave.setAttribute('disabled', '');
          this.buttonSave.classList.add('button--subdued');

          this.updateLoadingUI();
          this.updateFormUI();
        }

        this.buttonSave.removeAttribute('aria-busy');
        this.formSubmitting = false;
        this.updateButtonState();
      }
    }

    async onDeactivatePOCC(event) {
      if (!this.formSubmitting) {
        this.formSubmitting = true;
        this.buttonSave.setAttribute('aria-busy', 'true');
        const fetchAddServicesUrl = `${this.userDetails.profile.iss}/camlog-webhook-srv/additionalservice/addon`
        const poccUpdate = await fetch(fetchAddServicesUrl, {
          method: 'POST', 
          headers: {
            'Content-Type': 'application/json',
            'Authorization': `Bearer ${this.userDetails.access_token}` 
          },
          body: JSON.stringify({
            "pocc_postOperativeCareCoach": false
          })
        }).then((resp) => {
          return resp.json()
        });

        if (poccUpdate?.success) {
          this.enabled = false;
          this.classList.remove('enabled');
          this.inputDate.value = '';
          this.inputConsent.checked = false;
        }

        this.buttonSave.removeAttribute('aria-busy');
        this.formSubmitting = false;
        this.updateButtonState();
      }
    }

    async onActivatePOCC(event) {
      if (!this.formSubmitting) {
        this.formSubmitting = true;
        this.buttonActivate.setAttribute('aria-busy', 'true');
        const fetchAddServicesUrl = `${this.userDetails.profile.iss}/camlog-webhook-srv/additionalservice/addon`
        const poccUpdate = await fetch(fetchAddServicesUrl, {
          method: 'POST', 
          headers: {
            'Content-Type': 'application/json',
            'Authorization': `Bearer ${this.userDetails.access_token}` 
          },
          body: JSON.stringify({
            "pocc_postOperativeCareCoach": true,
            "pocc_surgeryDate": this.inputDate.value
          })
        }).then((resp) => {
          return resp.json()
        });

        if (poccUpdate?.success) {
          const poccObject = await fetch(`${this.userDetails.profile.iss}/camlog-webhook-srv/additionalservice/addon`, {
            method: 'GET',
            headers: {
              'Content-Type': 'application/json',
              'Authorization': `Bearer ${this.userDetails.access_token}`
            }
          }).then((resp) => {
            return resp.json()
          });

          this.additionalServices = poccObject;
          window.cidaasVariables.additional_services = poccObject;

          this.enabled = true;
          this.classList.add('enabled');

          this.updateLoadingUI();
          this.updateFormUI();
        }

        this.buttonActivate.removeAttribute('aria-busy');
        this.formSubmitting = false;
        this.updateButtonState();
      }
    }

    updateButtonState() {
      if (!this.enabled) {
        if (this.inputDate.value && this.inputConsent.checked) {
          this.buttonActivate.removeAttribute('disabled');
          this.buttonActivate.classList.remove('button--subdued');
          this.buttonDeactivate.style.display = "none";
          this.buttonReset.style.display = "none";
        } else {
          this.buttonActivate.setAttribute('disabled', '');
          this.buttonActivate.classList.add('button--subdued');
          this.buttonReset.style.display = "none";
          this.buttonDeactivate.style.display = "none";
        }
      } else {
        if (this.inputDate.value && this.additionalServices?.data?.pocc_surgeryDate != this.inputDate.value) {
          this.buttonSave.removeAttribute('disabled');
          this.buttonSave.classList.remove('button--subdued');
          this.buttonReset.style.display = "block";
          this.buttonDeactivate.style.display = "none";
        } else {
          this.buttonSave.setAttribute('disabled', '');
          this.buttonSave.classList.add('button--subdued');
          this.buttonReset.style.display = "none";
          this.buttonDeactivate.style.display = "block";
        }
      }
    }

    attachEventListeners() {
      window.addEventListener(
        "cidaas:userDetails",
        this.userDetailsLoaded.bind(this)
      );

      window.addEventListener(
        "cidaas:additionalServices",
        this.additionalServicesLoaded.bind(this)
      );

      this.checkLoadingState();
    }

    checkLoadingState() {
      if ((this.userDetails && this.additionalServices) || window?.cidaasVariables?.shopify?.design_mode) {
        this.loaded = true;

        window.debugMode && console.log(
          "[cidaas-pocc]",
          "All variables loaded"
        );
      }

      this.updateLoadingUI();
      this.updateFormUI();
    }

    updateFormUI() {
      if (this.loaded) {
        const hasPostOperativeCareCoach = !!this.additionalServices?.data?.pocc_postOperativeCareCoach;

        if (hasPostOperativeCareCoach) {
          this.enabled = true;
          this.classList.add('enabled');

          const dateInput = this.querySelectorAll('[name="selected_date"]');
          const poccDateTime = this.additionalServices?.data?.pocc_surgeryDate;

          if (poccDateTime) {
            const poccDate = poccDateTime?.split(' ')[0];
            // save year-month-day to last date
            const poccDateObject = new Date(poccDate);
            const formattedDate = poccDateObject.toISOString().split('T')[0];
            this.lastDate = formattedDate;
  
            if (dateInput?.length > 0) {
              dateInput?.forEach((input) => {
                input.value = poccDate;
              });
            }
          }
        } else {
          this.enabled = false;
          this.classList.remove('enabled');
        }
        window.debugMode && console.log(
          "[cidaas-pocc]",
          "Updating pocc UI"
        );
      }
    }

    updateLoadingUI() {
      if (this.loaded) {
        this.querySelector('cidaas-loading').setAttribute('hidden', '');
        this.querySelector('cidaas-loaded').removeAttribute('hidden');
      } else {
        this.querySelector('cidaas-loading').removeAttribute('hidden');
        this.querySelector('cidaas-loaded').setAttribute('hidden', '');
      }
    }

    userDetailsLoaded(data) {
      window.debugMode &&
        console.log(
          "[cidaas-pocc]",
          "User details loaded",
          true
        );
      this.userDetails = data.detail;
      this.checkLoadingState();
    }

    additionalServicesLoaded(data) {
      window.debugMode &&
        console.log(
          "[cidaas-pocc]",
          "Additional services loaded",
          true
        );
      this.additionalServices = data.detail;
      this.checkLoadingState();
    }

  }
  
  if (!window.customElements.get("cidaas-pocc")) {
    window.customElements.define("cidaas-pocc", CidaasPOCC);
  }
  
  window.debugMode &&
    console.log(
      "[cidaas-pocc]",
      "CidaasPOCC custom element defined"
    );
}